// extracted by mini-css-extract-plugin
export default {"price":"C6-z","onSale":"D6-z","msrpLabelPrice":"E6-z","msrpLabel":"F6-z","originalPrice":"G6-z","percentOff":"H6-z"};